import KeyValueTable from './KeyValueTable';
import { KeyValueTableProps, KeyValueTableValueProps } from './types';

export type { KeyValueTableProps, KeyValueTableValueProps };
export default KeyValueTable;
